import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 22 21",
	...props,
	children: [/* @__PURE__ */ _jsx("path", { d: "M21.742 10.478c0 5.755-4.666 10.421-10.421 10.421C5.566 20.899.9 16.233.9 10.478.9 4.723 5.566.057 11.321.057c5.755 0 10.421 4.666 10.421 10.42Z" }), /* @__PURE__ */ _jsx("path", {
		fill: "#fff",
		d: "M10.867 8.457c0-.247.059-.414.177-.5.119-.097.285-.146.5-.146.216 0 .383.049.5.146.13.086.194.253.194.5v7.035c0 .248-.064.42-.193.517-.118.085-.285.129-.5.129-.216 0-.382-.044-.5-.13-.119-.096-.178-.268-.178-.516V8.457Zm-.194-2.872c0-.28.08-.495.242-.646a.886.886 0 0 1 .63-.242.83.83 0 0 1 .613.242c.172.15.258.366.258.646s-.086.5-.258.661a.863.863 0 0 1-.613.226.922.922 0 0 1-.63-.226c-.161-.161-.242-.382-.242-.661Z"
	})]
});
export default SvgInfo;
